import React from 'react';
import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { StickyContainer } from 'react-sticky';
import { PreauthFooterV3 } from '@zola/zola-ui/src/components/PreAuthV3';
import { asyncComponent } from 'util/asyncComponent';
import { getRoutingPathname } from 'selectors/routingSelectors';
import { getUserContext } from 'selectors/user/userSelectors';
import { useAppSelector } from 'reducers/useAppSelector';
import { useMobileCheck } from 'cards/hooks/useMobileCheck';

import '../stylesheets/_invitations.less';

const CardsModalRoot = asyncComponent(() => import('../components/common/CardsModalRoot'));

const FooterWrapper = styled.div`
  ${MEDIA_QUERY.DESKTOP} {
    ${({ isGuest }) => (!isGuest ? `margin-left: 74px;` : ``)}
  }
`;

// * Public object to expose specific methods to other web
if (typeof window !== 'undefined') {
  window.zolaPaper = window.zolaPaper || {};
}

export default function Cards({ children }) {
  const routingPath = useSelector(getRoutingPathname);
  const userContext = useAppSelector(getUserContext);
  const isMobile = useMobileCheck();

  const isGuest = userContext ? userContext.is_guest : true;

  const hideFooterOnCustomizationFlow =
    routingPath.includes('/wedding-planning/custom') && !isMobile;

  return (
    <div>
      <div id="invitations" className="invitations">
        <StickyContainer>
          <div className="container-fluid">{children}</div>
        </StickyContainer>
        <CardsModalRoot />
      </div>
      {!hideFooterOnCustomizationFlow ? (
        <FooterWrapper isGuest={isGuest}>
          <PreauthFooterV3 isGuest={isGuest} />
        </FooterWrapper>
      ) : null}
    </div>
  );
}

Cards.propTypes = {
  children: PropTypes.element,
};
